<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title: string;
    subtitle?: string;
    summary?: string;
    invert?: boolean;
    centerTitle?: boolean;
    size?: string;
  }>(),
  {
    invert: false,
    centerTitle: true,
    size: "medium",
    subtitle: undefined,
    summary: undefined,
  },
);
</script>

<template>
  <div
    v-motion-fade-visible-once
    :delay="200"
    :class="[
      'section-header',
      { invert: props.invert },
      { 'center-title': props.centerTitle },
      { large: props.size === 'large' },
    ]"
  >
    <small class="typeface-regular" v-if="props.subtitle">{{
      props.subtitle
    }}</small>
    <h1 :class="{ 'typeface-title': props.size === 'large' }">
      {{ props.title }}
    </h1>
    <div
      v-motion-fade-visible-once
      :delay="200"
      v-if="props.summary"
      class="summary"
    >
      <p class="typeface-summary">{{ props.summary }}</p>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/breakpoints.pcss";
.section-header {
  max-width: 20rem;
  @mixin screen xs {
    max-width: 40rem;
  }
}

.center-title {
  text-align: left;
  margin: 0 1rem;
  @mixin screen md {
    text-align: center;
    margin: 0 auto;
    p {
      margin: 0 auto 2.5rem;
    }
  }
}

small {
  color: var(--color-rose-500);
  margin-bottom: 0.5rem;
  display: block;
}
h1 {
  color: var(--color-black);
  margin-top: 1rem;
  margin-bottom: 1rem;
}
p {
  color: var(--color-slate-400);
  max-width: 30rem;
}

.invert {
  h1 {
    color: var(--color-white);
  }
  p {
    color: var(--color-slate-200);
  }
}

.large {
  h1 {
    font-weight: 500;
  }
}
</style>
